// extracted by mini-css-extract-plugin
module.exports = {"placemark":"Placemark_placemark__O9Agl","text":"Placemark_text__tmslJ","icon":"Placemark_icon__k_osh"};